<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>
    <div class="px-2 mt-1">
      <div class="card card-height">
        <div class="row mt-2 gy-1">
          <div class="row mt-1">
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Name</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  placeholder="Name...."
                  v-model="formData.name"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Start Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.start_date"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">End Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.end_date"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 mt-1">
              <label class="form-label">Direct Supervisor Only: </label>
              <input type="checkbox" v-model="formData.direct_supervisor_only" class="form-check-input">
            </div>

            <div  class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="align-middle">Status</label>
              <v-select
                  placeholder="Select Status"
                  v-model="formData.status"
                  :options="performanceApprisalSetupType"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Ongoing Start Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.ongoing_start_date"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Ongoing End Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.ongoing_end_date"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP()"
              class="btn btn-primary">
        Save
      </button>
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP(false)"
              class="btn btn-primary">Save & New
      </button>
      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <GlobalLoader/>
  </div>
</template>
<script setup>
import {computed, inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useStore} from "vuex";


const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})

let loader =ref(false)
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let headerTitle = ref("Add Performance Appraisal Setup")
let contacts = ref([])
let performanceEditData = ref({})
const performanceApprisalSetupType = ref([]);

let performanceData = {}
let formData = ref({
  company_id: companyId,
  status: 'active',
  name:'',
  start_date:'',
  end_date:'',
  ongoing_start_date:'',
  ongoing_end_date:'',
  direct_supervisor_only:false,
})

function navigateToListPage() {
  delete route.query.performanceApprisalId;
  router.push({name: `performance-appraisal-setup`, params: route.params, query: route.query});
}

const {
  createPerformanceApprisalSetup,
  fetchSinglePerformanceApprisalSetup,
  updatePerformanceApprisalSetup,
  fetchTypes,
} = handleHrPayroll()

function saveAP(redirect = true) {
  if (isCreate.value) {
    handleSubmit(redirect);
  } else {
    handleUpdate(redirect);
  }
}

function handleSubmit(redirect) {
  performanceData.company_id  = formData.value.company_id;
  performanceData.status = formData.value.status;
  performanceData.name = formData.value.name;
  performanceData.start_date = formData.value.start_date;
  performanceData.end_date = formData.value.end_date;
  performanceData.ongoing_start_date = formData.value.ongoing_start_date;
  performanceData.ongoing_end_date = formData.value.ongoing_end_date;
  performanceData.direct_supervisor_only = formData.value.direct_supervisor_only;

  createAP(redirect);
}

function handleUpdate(redirect) {
  performanceData.id = formData.value.id;
  performanceData.company_id  = formData.value.company_id;
  performanceData.status = formData.value.status;
  performanceData.name = formData.value.name;
  performanceData.start_date = formData.value.start_date;
  performanceData.end_date = formData.value.end_date;
  performanceData.ongoing_start_date = formData.value.ongoing_start_date;
  performanceData.ongoing_end_date = formData.value.ongoing_end_date;
  performanceData.direct_supervisor_only = formData.value.direct_supervisor_only;

  updateAPData(redirect);
}

function createAP(redirect = true) {
  createPerformanceApprisalSetup(performanceData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message)
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function updateAPData(redirect = true) {
  updatePerformanceApprisalSetup(performanceData, performanceData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message);
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

function setFormData() {
  headerTitle.value = "Update Performance Appraisal Setup";
  formData.value.id =  performanceEditData.value.id;
  formData.value.name = performanceEditData.value.name;
  formData.value.start_date = performanceEditData.value.start_date;
  formData.value.end_date = performanceEditData.value.end_date;
  formData.value.ongoing_start_date = performanceEditData.value.ongoing_start_date;
  formData.value.ongoing_end_date = performanceEditData.value.ongoing_end_date;
  formData.value.direct_supervisor_only = performanceEditData.value.direct_supervisor_only === 1 ? true : false;
  formData.value.status = performanceEditData.value.status;
}

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      performanceApprisalSetupType.value = [];
      return
    }

    if (res.data && res.data.performanceApprisalSetupType) {
      performanceApprisalSetupType.value = res.data.performanceApprisalSetupType;
    }

  }).catch(err => {
    console.log(err)
  })
}

function onPageReload() {
  loader.value=true

  Promise.all([
    getTypes(),

  ]).finally(() => {
    loader.value = false
  })

  formData.value.start_date =  new Date().toISOString().split('T')[0]
  formData.value.end_date =  new Date().toISOString().split('T')[0]
  if(route.query.performanceApprisalId && route.query.performanceApprisalId !== '' && route.query.performanceApprisalId !== undefined){
    isCreate.value = false;
    const fetchData = fetchSinglePerformanceApprisalSetup(route.query.performanceApprisalId, getQuery());
    fetchData.then(res2 => {
      performanceEditData.value = res2.data;
      setFormData();
    });
  }
}

onMounted(() => {
  onPageReload();
})
</script>